import axios from "axios";
import { ADMIN_PORTAL_AUTH_TOKEN, ADMIN_PORTAL_API_BASE_URL } from "../utils/config";

export const getCacheDocs = async (cacheName, activeTab) => {
    const data = {
        cache_name: cacheName,
        source: activeTab === "ABCD App" ? "abcd" : "service"
    }
    let config = {
        method: "post",
        url: `${ADMIN_PORTAL_API_BASE_URL}/list_documents_in_cache`,
        data: data,
        headers: {
            Authorization: "Bearer " + ADMIN_PORTAL_AUTH_TOKEN
        }
    };
    try {
        const response = await axios(config);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}